// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { message } from 'antd'
import { fetchCityRoads } from '../api/road'
import $ from 'axios'
import { getRoadTypes } from '../utils/map'

function createCancelTokenSource () {
  return $.CancelToken.source()
}

const roadFetchCancelErrorMessage = 'BUILT-IN:Operation canceled.'
const gatewayForwardFetchErrorMessage = 'forward url /worldcam/getroads failed'
let roadFetchSource = createCancelTokenSource()

export const road = {
  state: {
    roads: []
  },
  reducers: {
    updateRoads: (state, roads) => ({ ...state, roads }),
    clear () {
      return {
        roads: []
      }
    }
  },
  effects: dispatch => ({
    async fetchRoadData (_, rootState) {
      roadFetchSource.cancel(roadFetchCancelErrorMessage)
      roadFetchSource = createCancelTokenSource()
      const { boundingBox } = rootState.map
      let roads
      try {
        const zoomLevel = rootState.map.zoom[0]
        const roadTypes = getRoadTypes(zoomLevel)
        if (zoomLevel <= 13) {
          return
        }
        roads = await fetchCityRoads({ boundingBox, roadTypes }, roadFetchSource.token)
        roads = roads || []
        roads = roads.map(road => {
          const name = road.tags ? road.tags.name : 'No Name'
          return {
            id: road.id,
            type: 'Feature',
            properties: {
              roadID: road.id,
              name
            },
            geometry: {
              type: 'LineString',
              coordinates: road.path.coordinates.map(x => x.reverse())
            }
          }
        })
      } catch (e) {
        const errMessage = e.toString() || ''
        if (errMessage.match(roadFetchCancelErrorMessage)) {
          return
        }
        if (errMessage.match(gatewayForwardFetchErrorMessage)) {
          message.info('(>﹏<) Failed to get roads, maybe zoom in the map can solve the problem', 3)
          return
        }
        message.error('Fetch Roads Error' + errMessage)
      }
      if (roads) {
        await dispatch.road.updateRoads(roads)
      }
    }
  })
}
